/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiAgentReportCreateRequest {
    getFixupPrototypeFunction() { return AiAgentReportCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<AiAgentReportCreateRequest>): AiAgentReportCreateRequest {
        let obj = Object.assign(new AiAgentReportCreateRequest(), model);
        AiAgentReportCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiAgentReportCreateRequest>): AiAgentReportCreateRequest {
        if (!model) return null;
        return AiAgentReportCreateRequest.newInstance(<AiAgentReportCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiAgentReportCreateRequest) {
        if (!obj) return;

        models.AiAgentReportCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiAgentReportCreateRequest): boolean {
        Object.setPrototypeOf(obj, AiAgentReportCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.configuration) {
            models.ReportConfigurationForAiAgent.fixupPrototype(this.configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    configuration: models.ReportConfigurationForAiAgent;

}
